import { createSelector } from 'reselect'
import initialState from 'SRC/modules/redux/initialState'

const defaultParams = initialState.user.profile.pagination.params

export const getProfilePaginationParams = createSelector(
  (state) => state && state.user && state.user.profile && state.user.profile.pagination && state.user.profile.pagination.params
    ? state.user.profile.pagination.params : defaultParams,
  (params) => params
)
